import { render, staticRenderFns } from "./UploadCompanies.vue?vue&type=template&id=14c41f9c&scoped=true&"
import script from "./UploadCompanies.vue?vue&type=script&lang=js&"
export * from "./UploadCompanies.vue?vue&type=script&lang=js&"
import style0 from "./UploadCompanies.vue?vue&type=style&index=0&id=14c41f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c41f9c",
  null
  
)

export default component.exports